<div class="flx-text-highlight-element" [ngStyle]="highlightElementContainerStyle" [innerHtml]="highlightedText" #highlightElement></div>